import { type AdminUser, type RawAdminUser } from '../../types'

export const adminUserMapper = (rawAdminUser: RawAdminUser[]): AdminUser[] =>
  rawAdminUser.map(
    (raw: RawAdminUser): AdminUser => ({
      ...raw,
      selected: false
    })
  )
